<template>
    <div id="home">
        <!-- banner -->
        <div class="swiper home-img">
            <swiper ref="mySwiper1" :options="swiperOptions1" v-if="bannerList.length">
                <swiper-slide style="cursor:pointer;" v-for="(item, index) in bannerList" :key="index">
                    <img loading="lazy" @click="bannerTransgo(item)" class="img banner"
                        :src="$common.getImgUrl(item.picture || item.pictureApp)" alt />
                </swiper-slide>
            </swiper>
            <div class="swiper-pagination"></div>
            <!-- <img loading="lazy" v-lazy="require('../../assets/images/amjs/banner.png')" alt=""> -->
        </div>
        <div id="amjs-warp">
            <!-- 公告 -->
            <div class="notice">
                <div class="amjs-wrapper">
                    <Notice></Notice>
                </div>
            </div>

            <!-- 游戏 -->
            <div id="game-box">
                <div class="amjs-wrapper">
                    <div class="game-tabs">
                        <div class="tabs-div">
                            <div class="tabs-box">
                                <div class="swiper" v-if="EgameData.length">
                                    <swiper ref="mySwiper2" :options="swiperOptions2" @mouseenter.native="mouseEnter"
                                        @mouseleave.native="mouseLeave" @mouseover.native="changeEgame">
                                        <template v-for="(item, index) in EgameData">
                                            <swiper-slide :key="index" v-if="item.nameEn != 'fishing'">
                                                <div :class="EgameIndex == index ? 'item active' : 'item'"
                                                    :data-item="func_str(item, index)">
                                                    <img loading="lazy" v-lazy="item.imgUrl"
                                                        :data-item="func_str(item, index)">
                                                    <span :data-item="func_str(item, index)">{{ item.name }}</span>
                                                </div>
                                            </swiper-slide>
                                        </template>
                                    </swiper>
                                    <div class="btn_prevs btn1">
                                        <img loading="lazy" v-lazy="require('../../assets/images/amjs/prev.png')" />
                                    </div>
                                    <div class="btn_next btn1">
                                        <img loading="lazy" v-lazy="require('../../assets/images/amjs/next.png')" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="game-bottom">
                        <div v-if="!EgameChild.length" class="nodata"><span>暂无数据</span></div>
                        <ul v-else class="game-lists" v-loading="loading">
                            <li v-for="(item, index) in EgameChild" :key="index">
                                <div class="game-li-top" @click="getToken(item, 1)">
                                    <img loading="lazy"
                                        v-lazy="item.pictureUrl ? $common.getImgUrl(item.pictureUrl) : defaultImg"
                                        @error="defImg()" />>
                                </div>
                                <div class="game-li-bottom">{{ item.name }}</div>
                            </li>
                        </ul>
                        <div class="ranking">
                            <div class="rank-jackpot">
                                <span>超级彩金JACKPOT</span>
                                <p>CNY {{ number.toFixed(2) }}</p>
                            </div>
                            <div class="rank-tit"></div>
                            <div class="rank-jtop">
                                <span>客户ID</span>
                                <span>游戏名称</span>
                                <span>金额</span>
                            </div>
                            <div class="rank-lists">
                                <div class="winNotice">
                                    <vue-seamless-scroll :data="dataObject" :class-option="classOption">
                                        <ul class="item">
                                            <li v-for="(item, index) in dataObject" :key="index">
                                                <span class="list-user">{{ item.dataList[0].username }}</span>
                                                <span>{{ item.gameName }}</span>
                                                <span class="list-num">{{ item.dataList[0].jackpot }}</span>
                                            </li>
                                        </ul>
                                    </vue-seamless-scroll>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 四方块 -->
            <AmjsCasino v-if="isAmjs" />
            <div v-else id="home-casino">
                <div class="casino-mask">
                    <div class="amjs-wrapper">
                        <div class="content-casino">
                            <a href="./live" class="live"></a>
                            <a href="./sport" class="sport"></a>
                            <a href="./lottery" class="lottery"></a>
                            <a href="./chess" class="board"></a>
                        </div>
                    </div>
                </div>
            </div>

            <!-- app下载 -->
            <div id="down-code">
                <div class="down-left">
                    <LeftImages />
                </div>
                <div class="down-right">
                    <div class="tit">掌上娱乐，随时随地，无限畅玩</div>
                    <div class="context">
                        {{ $t("titilName")
                        }}手机APP完美上线，汇聚全球顶级平台额度无需转换。提供近万款电子游艺、真人视讯、彩票游戏、棋牌对战、捕鱼达人、体育竞技。支持手机一键存/取，方便快捷，财富尽在掌握！
                    </div>
                    <div class="context_bottom">
                        <div class="mobiel_box">
                            <div class="btn-box btn-adr" @click="downApp()">安卓APP下载</div>
                            <div class="btn-box btn-ios" @click="downApp()">苹果APP下载</div>
                        </div>
                        <div class="qrcode_wrapper">
                            <div class="qrcode-cont">
                                <div id="qrcode1"></div>
                                <!-- <img loading="lazy" v-lazy="require('../../assets/images/amjs/code.png')" alt="code"> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <TimeDiscount ref="refTimeDiscount" @openFloat="onTimeDiscount"></TimeDiscount>
        <TimeDiscountDetail ref="refTimeDiscountDetail"></TimeDiscountDetail>
        <Signin ref="refSignin" :SigninData="signinData"></Signin>
        <!-- <jack-Pot @openSignin="openSignin"></jack-Pot> -->
        <JackPotNew />
    </div>
</template>

<script>
import "../../assets/css/amjs-home.scss";
import Notice from "../../components/notice";
import TimeDiscount from "../../components/TimeDiscount/TimeDiscount";
import TimeDiscountDetail from "../../components/TimeDiscount/TimeDiscountDetail";
import Signin from "../../components/Signin/Signin";
import JackPotNew from "../../components/jackPot/jackPotNew";
import LeftImages from "./leftImages.vue";
import AmjsCasino from "./amjsCasino.vue";
// import { showLogin } from "../login/login.js";
import QRCode from '@keeex/qrcodejs-kx';
var _this;
export default {
    components: {
        Notice,
        TimeDiscount,
        TimeDiscountDetail,
        Signin,
        JackPotNew,
        LeftImages,
        AmjsCasino,
        QRCode
    },
    data() {
        _this = this;
        return {
            isAmjs: false,
            loading: false,
            number: 20146358.54,
            EgameData: [], //电子游戏list
            EgameIndex: null, //电子游戏index
            EgameChild: [], //电子游戏子菜单
            defaultImg: require('@/assets/images/amjs/game1.jpg'),
            signinData: {},
            fishMenu: [], // 捕鱼游戏
            casinoMenu: [], // 电子游艺
            liveMenu: [], // 真人视讯
            hotMenu: [], // 热门游戏
            recommendMenu: [], // 推荐游戏
            gameIndex: 1,
            noShowDia: false,
            historyurl: "/",
            activityList: [], //活动前三个
            bannerList: [], //轮播图
            showPop: false,
            swiperOptions1: {
                loop: true,
                // spaceBetween: 10,
                autoplay: {
                    disableOnInteraction: false,
                },
                speed: 0,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
            },

            swiperOptions2: {
                loop: true,
                slidesPerView: 8,
                autoplay: {
                    delay: 500,
                    disableOnInteraction: false,
                },
                speed: 1000,
                navigation: {
                    nextEl: '.btn_next',
                    prevEl: '.btn_prevs'
                },
            },
            swiperOptions3: {},
            flag: false,
            dataObject: [],
            // 平台游戏选中
            platformActive: 0,
            platformActiveName: "egame",
            // platformData: {},
            // platformBg: [
            //     { img: require("@/assets/images/mb/index-banner1.png") },
            //     { img: require("@/assets/images/mb/index-banner2.jpg") },
            //     { img: require("@/assets/images/mb/index-banner3.jpg") }
            // ],
            TimeDiscountList: [],
            platformData: {
                egame: {
                    // main: {
                    //     img: require("../../assets/images/mb/index-banner1.png"),
                    //     jump_url: "http://www.baidu.com"
                    // },
                    // lists: [],
                    // list: [
                    //     {
                    //         img: require("@/assets/images/mb/casino-banner1.png")
                    //     },
                    //     {
                    //         img: require("@/assets/images/mb/casino-banner2.png")
                    //     },
                    //     {
                    //         img: require("@/assets/images/mb/casino-banner3.png")
                    //     },
                    //     {
                    //         img: require("@/assets/images/mb/casino-banner4.png")
                    //     },
                    //     {
                    //         img: require("@/assets/images/mb/casino-banner5.png")
                    //     },
                    //     {
                    //         img: require("@/assets/images/mb/casino-banner6.png")
                    //     },
                    //     {
                    //         img: require("@/assets/images/mb/casino-banner7.png")
                    //     },
                    //     {
                    //         img: require("@/assets/images/mb/casino-banner8.png")
                    //     }
                    // ]
                },

                live: {
                    // main: {
                    //     img: require("../../assets/images/mb/index-banner2.jpg"),
                    //     jump_url: "http://www.baidu.com"
                    // },
                    // lists: [],
                    // list: [
                    //     {
                    //         img: require("@/assets/images/mb/live-banner1.png")
                    //     },
                    //     {
                    //         img: require("@/assets/images/mb/live-banner2.png")
                    //     },
                    //     {
                    //         img: require("@/assets/images/mb/live-banner3.png")
                    //     }
                    // ]
                },
                fish: {
                    // main: {
                    //     img: require("../../assets/images/mb/index-banner3.jpg"),
                    //     jump_url: "http://www.baidu.com"
                    // },
                    // lists: [],
                    // list: [
                    //     {
                    //         img: require("@/assets/images/mb/fish-banner1.png")
                    //     },
                    //     {
                    //         img: require("@/assets/images/mb/fish-banner2.png")
                    //     },
                    //     {
                    //         img: require("@/assets/images/mb/fish-banner3.png")
                    //     },
                    //     {
                    //         img: require("@/assets/images/mb/fish-banner4.png")
                    //     },
                    //     {
                    //         img: require("@/assets/images/mb/fish-banner5.png")
                    //     }
                    // ]
                }
            }
        };
    },
    filters: {
        todayTime(val) {
            var myDate = new Date();
            // myDate.getYear();        //获取当前年份(2位)
            let year = myDate.getFullYear(); //获取完整的年份(4位,1970-????)
            let month = myDate.getMonth() + 1; //获取当前月份(0-11,0代表1月)
            let day = myDate.getDate(); //获取当前日(1-31)
            // myDate.getDay();         //获取当前星期X(0-6,0代表星期天)
            // myDate.getTime();        //获取当前时间(从1970.1.1开始的毫秒数)
            // myDate.getHours();       //获取当前小时数(0-23)
            // myDate.getMinutes();     //获取当前分钟数(0-59)
            // myDate.getSeconds();     //获取当前秒数(0-59)
            // myDate.getMilliseconds();    //获取当前毫秒数(0-999)
            // myDate.toLocaleDateString();     //获取当前日期
            // var mytime=myDate.toLocaleTimeString();     //获取当前时间
            // myDate.toLocaleString( );        //获取日期与时间
            return year + "年" + month + "月" + day + "日";
        }
    },
    beforeRouteEnter(to, from, next) {
        //监听页面刷新
        next(vm => {
            vm.historyurl = from.path;
            let noShowDia = vm.$cache.get("noShowDia");
            if (vm.historyurl == "/") {
                vm.showPop = true; //显示弹框
            } else if (
                (vm.historyurl == "/" && noShowDia == false) ||
                noShowDia == "false" ||
                noShowDia == null
            ) {
                vm.showPop = true; //显示弹框
            } else {
                vm.showPop = false;
            }
        });
    },
    mounted() {
        this.banner();
        this.isAmjs = window.projectImgUrl == 'amjs' ? true : false;
        this.getDataType();
        // this.showPop = true; //显示弹框
        // this.getHomeData();
        this.getHotList();
        this.getRecommendList();

        this.getActivityData();
        this.getJackpot();
        // this.getHomePlatform();
        this.clientCode();
        setInterval(() => {
            this.number += 423.36;
            if (this.number > 99999999) { this.number = 10000000 }
        }, 1000);
    },
    methods: {
        mouseEnter() {
            this.$refs["mySwiper2"].$swiper.autoplay.stop();
        },
        mouseLeave() {
            this.$refs["mySwiper2"].$swiper.autoplay.start();
        },
        defImg() {
            let img = event.srcElement;
            img.src = this.defaultImg;
            img.onerror = null; //防止闪图
        },
        //活动详情
        async getActDetail(item) {
            if (item.type == 3 && item.activityExtensionsVo.url) {
                //跳转链接
                window.open(item.activityExtensionsVo.url);
            } else if (item.activityExtensionsVo && item.activityExtensionsVo.type == 4) {  //跳转游戏
                if (!this.$common.getUser()) {
                    this.$message.warning('请先登录！');
                } else {
                    this.getToken(item.activityExtensionsVo.activityGame, 1)
                }
            } else {
                //打开活动详情
                this.$router.push({
                    path: '/discount',
                    query: {
                        id: item.id
                    }
                })
            }
        },
        // 进入游戏
        getToken: async function (req, index) {
            let self = this;
            var issafariBrowser = /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);

            if (!self.$common.getUser()) {
                self.$message.warning('请登录')
                return
            }
            self.tenantId = self.$common.getUser().tenant_id
            self.username = self.$common.getUser().username
            self.uid = self.$common.getUser().user_id
            let datas = {
                tenantId: self.tenantId,
                username: self.username,
                gameId: index == 2 ? req.ids : req.id,
                clientIp: self.$config.clientIp,
                memberId: self.uid,
                terminalType: 1
            }
            self.$common.setGameRequestData(datas)

            const res = await self.$http.post(this.$api.getToken, datas, true)
            if (res.code == 0) {
                self.gameUrl = res.data;
                if (req.openMode === 1) {
                    // if(issafariBrowser) {
                    //  self.winOpen.location.href = self.gameUrl;
                    // }else{
                    window.open(self.gameUrl)
                    // }

                } else {
                    window.open(self.gameUrl)
                }

            } else {
                if (req.openMode === 1) {
                    window.open('/error.html?type=1')
                    // self.winOpen.location.href = '/error.html?type=1';
                }

                if (req.status === 0) {
                    self.$message.error('维护中')
                } else {
                    self.$message.error('进入游戏失败，请稍后重试！')
                }
            }
        },
        getJackpot() {
            this.$http.post(this.$api.getJackpotList).then(res => {
                if (res) {
                    this.dataObject = res.data;
                }
            });
        },
        openSignin(id) {
            this.$http
                .get(this.$api.getThematicActivitiesByApp + "/" + id, "", true)
                .then(res => {
                    if (res.code == 0) {
                        if (res.data.type == 2) {
                            //签到
                            this.signinData = res.data;
                            this.$refs.refSignin.centerDialogVisible = true;
                        } else {
                            //限时优惠详情
                            this.$refs.refTimeDiscountDetail.pageData =
                                res.data;
                            this.$refs.refTimeDiscountDetail.dialogVisible = true;
                        }
                    }
                });
        },
        differDeal(item, val, names) {
            if (names == "live") {
                this.getToken(item, 2);
            } else if (names == "fish") {
                this.getToken(item, 1);
            } else if (names == "egame") {
                localStorage.setItem("casinoCur", JSON.stringify(item));
                this.$router.push("egame");
            }
        },
        transGoToSec() {
            this.$router.push("egame");
        },
        //打开优惠详情
        openDis(item) {
            this.$router.push("/discount?id=" + item.id);
        },
        close() {
            this.showPop = false;
        },
        // 跳转到二级列表
        transgoSecond() {
            let val = this.platformActiveName;
            if (val == "egame") {
                this.$router.push("egame");
            } else if (val == "live") {
                this.$router.push("live");
            } else if (val == "fish") {
                this.$router.push("fish");
            }
        },
        // 数据获取
        getDataType() {
            let timer = setTimeout(() => {
                let result = JSON.parse(localStorage.getItem("game_menus_pc"));
                if (result) {
                    this.fishMenu = result.data.by;
                    this.casinoMenu = result.data.dz;
                    this.liveMenu = result.data.zb;
                    this.platformData.egame.lists = this.casinoMenu;
                    this.platformData.live.lists = this.liveMenu;
                    this.platformData.fish.lists = this.fishMenu;
                    this.getEgameData(result.data.dz)
                } else {
                    this.getDataType();
                }
            }, 1000);
        },

        // 热门游戏
        getHotList() {
            let self = this;
            self.$http.get(self.$api.hotGame).then((res, err) => {
                if (err) {
                } else {
                    if (res.code == 0) {
                        this.hotMenu = res.data;
                    }
                }
            });
        },

        // 推荐游戏
        getRecommendList() {
            let self = this;
            self.$http.get(self.$api.recommendGame).then((res, err) => {
                if (err) {
                } else {
                    if (res.code == 0) {
                        this.recommendMenu = res.data;
                    }
                }
            });
        },

        // banner图跳转
        bannerTransgo(item) {
            // return
            //1:外链 2:公告 3:活动 4:游戏 5:专题活动
            if (item.type === 1) {
                if (item.url) {
                    // window.open(item.url + '&title=' + item.title)
                    window.open(item.url);
                    // uni.navigateTo({
                    //     url: '../webViewQQ/webViewQQ?url=' + item.url + '&title=' + item.title
                    // });
                }
            } else if (item.type === 2) {
                if (!this.$common.getUser()) {
                    this.$message.warning(this.$t("enterGame.pleaseLogin"));
                    return;
                }
                if (item.id) {
                    this.$router.push("/my/service/notice");
                    let items = {
                        id: item.id
                    };
                    this.$store.commit("showSwiperNoticeDetail", items);
                }
            } else if (item.type === 3) {
                if (item.urlId) {
                    // this.$sk.navigateTo ('/pages/actDetail/actDetail?actDeId='+item.urlId)
                    this.$router.push({
                        //从活动列表进入
                        path: "/discount",
                        query: {
                            id: item.urlId
                        }
                    });
                }
            } else if (item.type === 4) {
                if (this.$common.getUser() && item.bannerGame.id) {
                    this.getToken(item.bannerGame, 1);
                } else {
                    this.$message.warning(this.$t("enterGame.pleaseLogin"));
                }
            } else if (item.type === 5) {
                if (item.expand && item.expand.actType == 3) {
                    // 双旦活动
                    this.jump11(item);
                    return;
                }
                this.$http
                    .get(
                        this.$api.getThematicActivitiesByApp + "/" + item.urlId,
                        "",
                        true
                    )
                    .then(res => {
                        if (res.code == 0) {
                            this.$refs.refTimeDiscountDetail.pageData =
                                res.data;
                            this.$refs.refTimeDiscountDetail.dialogVisible = true;
                        }
                    });
            } else if (item.type === 7) {
                if (item.needLogin == 1 && !this.$common.getUser()) {
                    this.$message.warning(this.$t("enterGame.pleaseLogin"));
                    return;
                }
                this.$router.push({ path: item.url })
            }
        },
        // 跳转双11
        jump11(item) {
            if (!this.$common.getUser()) {
                this.$message.warning('请先登录！');
                return;
            }
            const obj = {
                activityId: item.urlId,
                token: this.$common.getToken(),
                clientCode: window.clientCode,
                username: this.$common.getUser().username,
                language: "zh_CN",
                theme: window.theme,
                host: this.$config.baseUrl,
            };
            const str = window.btoa(JSON.stringify(obj));
            // const url = item.expand.actUrl + "/pc/index.html?s=" + str;
            const url = window.location.origin + '/func/' + item.expand.actFolder + "/pc/index.html?s=" + str;
            window.open(url);
        },
        // 进入游戏
        getToken: async function (req, index) {
            // return
            let self = this;
            var issafariBrowser =
                /Safari/.test(navigator.userAgent) &&
                !/Chrome/.test(navigator.userAgent);

            if (!self.$common.getUser()) {
                // self.showLogin = true;
                self.$message.warning(self.$t("indexPage.pleaseLogin"));
                return;
            }
            self.tenantId = self.$common.getUser().tenant_id;
            self.username = self.$common.getUser().username;
            self.uid = self.$common.getUser().user_id;
            let datas = {
                tenantId: self.tenantId,
                username: self.username,
                gameId: index == 2 ? req.ids : req.id,
                clientIp: self.$config.clientIp,
                memberId: self.uid,
                terminalType: 1
            };
            self.$common.setGameRequestData(datas);

            const res = await self.$http.post(this.$api.getToken, datas, true);
            if (res.code == 0) {
                self.gameUrl = res.data;
                if (req.openMode === 1) {
                    // if(issafariBrowser) {
                    //  self.winOpen.location.href = self.gameUrl;
                    // }else{
                    window.open(self.gameUrl);
                    // }
                } else {
                    window.open(self.gameUrl);
                }
            } else {
                self.$message.error(self.$t('indexPage.repair'))
                // if (req.openMode === 1) {
                //     window.open("/error.html?type=1");
                //     // self.winOpen.location.href = '/error.html?type=1';
                // }

                // if (req.status === 0) {
                //     self.$message.error(self.$t("indexPage.repair"));
                // } else {
                //     self.$message.error(self.$t("indexPage.failed"));
                // }
            }
        },

        // 限时优惠
        onTimeDiscount(TimeDiscountList) {
            this.TimeDiscountList = TimeDiscountList;
            // let isopen = this.$cache.get("discount");
            // if (TimeDiscountList.length > 0 && this.historyurl == "/") {
            //     // 说明是页面f5强制刷新
            //     if (isopen == false || isopen == "false" || isopen == null && this.flag) {
            //         // 没有选择不再显示则继续弹出
            //           this.$refs.refTimeDiscount.dialogVisible = true;
            //     }
            // }
        },
        // 弹框轮播打开游戏
        openGame(item) {
            item["id"] = item.gameId;
            this.getToken(item, 1);
        },
        popInputchange() {
            this.$cache.set("noShowDia", this.noShowDia);
        },
        getHomeData: async function () {
            let self = this;
            const res = await self.$http.get(self.$api.menusList);
            if (res.code == 0) {
                console.log('??????????', res.data)
                self.getEgameData(res.data);
            } else {
                this.$message.error(res.msg);
            }
        },
        //电子游戏
        getEgameData(arr) {
            this.EgameData = [...arr];
            this.vendorGame(this.EgameData[0], 0);
            // var that = this;
            // var arr_new = [];
            // for (var i = 0; i < arr.length; i++) {
            //     var data = arr[i];
            //     if (true) {
            //         data.imgUrl = that.$common.getImgUrl(data.imgUrl);
            //         if (data.imgUrl != that.$config.imgHost) {
            //             arr_new.push(data);
            //         }
            //     }
            // }
            // that.EgameData = arr_new;
            // that.vendorGame(arr_new[0],0);
            // arr.forEach(function(item) {
            //     if (item.nameEn == "CASINO") {
            //         //电子游艺
            //         var arr = item.children;
            //         var arr_new = [];
            //         for (var i = 0; i < arr.length; i++) {
            //             var data = arr[i];
            //             if (true) {
            //                 data.imgUrl = that.$common.getImgUrl(data.imgUrl);
            //                 if (data.imgUrl != that.$config.imgHost) {
            //                     arr_new.push(data);
            //                 }
            //             }
            //         }
            //         that.EgameData = arr_new;
            //         that.vendorGame(arr_new[0],0);
            //     }
            // });
        },
        func_str(item, index) {
            item.index = index;
            return JSON.stringify(item);//将当前的item对象转换为字符串
        },
        changeEgame(event) {
            if (event.target.dataset.item) {
                let item = JSON.parse(event.target.dataset.item);//转换为对象
                this.vendorGame(item, item.index)
            }
        },
        //电子游戏子菜单
        vendorGame(item, index) {
            if (index == this.EgameIndex) return;
            this.loading = true;
            let datas = {
                currentPage: 1,
                pageSize: 10,
                gameKindId: item.parentId,
                vendorId: item.ids
            };
            this.EgameIndex = index;
            this.$http.post(this.$api.vendorGame, datas).then((res) => {
                if (res.code == 0) {
                    this.EgameChild = res.data.list;
                    this.loading = false;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        platformNavClick(type) {
            if (type == 1) {
                this.gameIndex = 2;
            } else {
                this.gameIndex = 1;
            }
            this.platformActive = type;
            switch (type) {
                case 0:
                    this.platformActiveName = "egame";
                    break;
                case 1:
                    this.platformActiveName = "live";
                    break;
                case 2:
                    this.platformActiveName = "fish";
                    break;
                case 3:
                    this.$router.push("/chess");
                    break;
            }
        },
        prev() {
            this.$refs["mySwiper2"].swiper.slidePrev();
        },
        next() {
            this.$refs["mySwiper2"].swiper.slideNext();
        },
        // mySwiper3TransitionEnd() {},
        // 轮播图
        banner: async function () {
            let _this = this;
            try {
                var res = await _this.$http.get(_this.$api.banner);
            } catch {
                //接口报错处理
                _this.bannerReqSuccess = false;
            }

            if (res.code == 0) {
                _this.bannerList = res.data;
                console.log("_this.bannerList",_this.bannerList)
                if (res.data.length > 0) {
                    _this.bannerReqSuccess = true;
                } else {
                    _this.bannerReqSuccess = false;
                }
            } else {
                _this.bannerReqSuccess = false;
                this.$message.error(res.msg);
            }
        },
        // 优惠活动
        async getActivityData(currentPage = 1, pageSize = 3) {
            var _this = this;

            // _this.loadingType = "loading"; //显示正在加载中。。。。
            var data = {
                currentPage: 1,
                pageSize: 3
            };
            var res = await _this.$http.post(_this.$api.activity, data);
            if (res.code == 0) {
                this.activityList = res.data.content;
            } else {
                _this.actListReqSuccess = false;
                this.$message.error(res.msg);
            }
        },
        clientCode() {
            setTimeout(() => {
                const datas = this.$common.getConfigUrl()
                if (datas) {
                    this.codeList()
                } else {
                    this.clientCode()
                }
            }, 1000)
        },
        codeList() {
            // let that = this;
            // that.sessData = JSON.parse(sessionStorage.getItem('inviteCode'));
            // let u = window.location.hostname;
            // let a = u.split('.');
            // if (a.length > 2){
            //     a = a.slice(a.length - 2);
            // }
            // let s = 'http://m.' + a.join('.');
            // that.sessData = JSON.parse(sessionStorage.getItem('inviteCode'));
            // let arrNew = '';
            // if (that.sessData) {
            //     arrNew = s + '?code=' + that.sessData;
            //     that.apkUrl = `${this.$config.dowUrl}${window.clientCode}${window.theme}/${that.sessData}`;
            // } else {
            //     arrNew = s;
            //     that.apkUrl = `${this.$config.dowUrl}${window.clientCode}${window.theme}`;
            // }
            // that.openUrl = arrNew;
            // this.qrcode('qrcode1',that.apkUrl);
            // this.qrcode('qrcode2',that.openUrl);
            let url = location.origin + '/downloadUrl?',
                iosUrl = this.$common.getIosDownloadUrl(),
                androidUrl = this.$common.getAndroidDownloadUrl(),
                pcUrl = this.$common.getPcDownloadUrl();
            url += 'code=' + window.childCode;
            if (iosUrl) {
                url += '&ios=' + encodeURIComponent(iosUrl)
            }
            if (androidUrl) {
                url += '&android=' + encodeURIComponent(androidUrl)
            }
            // if (pcUrl) {
            // 	url += '&pc=' + encodeURIComponent(pcUrl)
            // }
            this.apkUrl = url;
            this.qrcode('qrcode1', this.apkUrl)
        },
        qrcode(qrcodeId, qrcode) {
            new QRCode(qrcodeId, {
                'width': 220, // 设置宽度，单位像素
                'height': 220, // 设置高度，单位像素
                'text': qrcode // 设置二维码内容或跳转地址
            });
        },
        downApp() {
            window.open(this.apkUrl)
        },
    },

    computed: {
        // 弹出滚动滚屏
        classOption() {
            return {
                step: 0.6,
                limitMoveNum: 1
            };
        }
    },
    watch: {
        showPop(val) {
            if (!val) {
                this.flag = true;
                let isopen = this.$cache.get("discount");
                if (
                    this.TimeDiscountList.length > 0 &&
                    this.historyurl == "/"
                ) {
                    // 说明是页面f5强制刷新
                    if (
                        isopen == false ||
                        isopen == "false" ||
                        (isopen == null && this.flag)
                    ) {
                        // 没有选择不再显示则继续弹出
                        //暂时去掉
                        // this.$refs.refTimeDiscount.dialogVisible = true;
                    }
                }
            }
        }
    }
};
</script>
<style>
@import '../../assets/css/home.css';
</style>